import { Controller } from "@hotwired/stimulus"
import { enter, leave } from "el-transition"

// Connects to data-controller="notification-planung"
export default class extends Controller {
	static targets = ["notification"]

	connect() {
		window.notificationPlanung = this
	}

	open() {
		enter(this.notificationTarget)
	}

	close() {
		leave(this.notificationTarget)
	}
}
